import React, { useState } from "react";
import { Card, Button, Modal, Form } from "react-bootstrap";

export default function EmailTab() {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    accountType: "",
    sync: "",
  });

  const accountTypes = ["Email", "Facebook", "Twitter", "Instagram"];
  const syncOptions = ["Now", "1 month ago", "3 months ago", "6 months ago"];

  const handleSubmit = () => {
    console.log("Connected:", form);
    setShow(false);
  };

  return (
    <>
      {/* 🔥 INTERNAL CSS */}
      <style>{`
        .email-card {
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 20px;
        }
             .notes-wrapper{
  
              align-items: center;
          border: 1px solid #eee;
          padding: 10px;
          border-radius: 6px;
          background:#ffffff;

       }

        .email-title {
          font-weight: 600;
        }

        .email-sub {
          font-size: 13px;
          color: #666;
        }

        .connect-btn {
          background: #ff6a00;
          border: none;
          color: #fff;
          padding: 6px 14px;
          border-radius: 6px;
        }

        .connect-btn:hover {
          background: #e85d00;
        }

        /* MODAL */
        .modal-save {
          background: #ff6a00;
          color: #fff;
        }

        .modal-save:hover {
          background: #e85d00;
        }

        select:focus {
          border-color: #ff6a00 !important;
          box-shadow: 0 0 0 0.2rem rgba(255,106,0,0.2);
        }

        input[type="radio"]:checked {
          accent-color: #ff6a00;
        }

        /* MOBILE */
        @media(max-width:768px){
          .email-header{
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }
        }
      `}</style>

      {/* MAIN CARD */}
      <div className="p-3 notes-wrapper">
        <h5>Email</h5>

        <div className="email-card d-flex justify-content-between align-items-center email-header">
          <div>
            <div className="email-title">Manage Emails</div>
            <div className="email-sub">
              You can send and reply to emails directly via this section.
            </div>
          </div>

          <button className="connect-btn" onClick={() => setShow(true)}>
            Connect Account
          </button>
        </div>
      </div>

      {/* MODAL */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect Account</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* ACCOUNT TYPE */}
            <Form.Group className="mb-3">
              <Form.Label>Account Type *</Form.Label>
              <Form.Select
                value={form.accountType}
                onChange={(e) =>
                  setForm({ ...form, accountType: e.target.value })
                }
              >
                <option value="">Select</option>
                {accountTypes.map((type) => (
                  <option key={type}>{type}</option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* SYNC OPTIONS */}
            <Form.Group>
              <Form.Label>Sync emails from</Form.Label>

              {syncOptions.map((opt) => (
                <Form.Check
                  key={opt}
                  type="radio"
                  name="sync"
                  label={opt}
                  value={opt}
                  checked={form.sync === opt}
                  onChange={(e) =>
                    setForm({ ...form, sync: e.target.value })
                  }
                  className="mb-2"
                />
              ))}
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button className="modal-save" onClick={handleSubmit}>
            Connect Account
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}